import { getTermsContent, setUserConsent } from '../../auth/_requests';

export const SIGNUP_TERMS_ACCEPTED_KEY = 'signupTermsAccepted';
export const START_PAY_RENT_SETUP_KEY = 'startPayRentSetup';
export const SIGNUP_PAY_SETUP_HANDLED_KEY = 'signupPaySetupHandled';

/** Persist that the user checked T&C on the signup page (survives OAuth redirect). */
export function markSignupTermsAccepted(): void {
  sessionStorage.setItem(SIGNUP_TERMS_ACCEPTED_KEY, 'true');
}

export function clearSignupTermsAccepted(): void {
  sessionStorage.removeItem(SIGNUP_TERMS_ACCEPTED_KEY);
}

export function wasSignupTermsAccepted(): boolean {
  return sessionStorage.getItem(SIGNUP_TERMS_ACCEPTED_KEY) === 'true';
}

/** After email/OAuth signup, queue pay-rent setup once the user reaches the dashboard. */
export function markStartPayRentSetup(): void {
  localStorage.setItem(START_PAY_RENT_SETUP_KEY, 'true');
  sessionStorage.removeItem(SIGNUP_PAY_SETUP_HANDLED_KEY);
}

/**
 * Returns whether this session should skip the T&C modal and use the signup pay-setup path.
 * Consumes the one-shot localStorage flag on first call; later auth-token refreshes still
 * recognize the path via sessionStorage so the T&C modal is not re-opened.
 */
export function consumeStartPayRentSetup(): { fromSignup: boolean; shouldOpenPaySetup: boolean } {
  const pending = localStorage.getItem(START_PAY_RENT_SETUP_KEY) === 'true';
  if (pending) {
    localStorage.removeItem(START_PAY_RENT_SETUP_KEY);
    sessionStorage.setItem(SIGNUP_PAY_SETUP_HANDLED_KEY, 'true');
    return { fromSignup: true, shouldOpenPaySetup: true };
  }
  if (sessionStorage.getItem(SIGNUP_PAY_SETUP_HANDLED_KEY) === 'true') {
    return { fromSignup: true, shouldOpenPaySetup: false };
  }
  return { fromSignup: false, shouldOpenPaySetup: false };
}

/** Save tenant T&C consent for a newly registered user. Returns false if consent could not be saved. */
export async function saveSignupTermsConsent(token: string): Promise<boolean> {
  try {
    const termsResponse = await getTermsContent();
    const termsAndConditionId = termsResponse?.data?.termsAndConditionId;
    if (!termsAndConditionId) {
      return false;
    }
    const result = await setUserConsent(
      { termsAndConditionId: String(termsAndConditionId) },
      token
    );
    return Boolean(result);
  } catch (error) {
    console.error('Error saving signup terms consent:', error);
    return false;
  }
}
